import React from "react";
import { AiFillCloseCircle } from "react-icons/ai";
import { useDispatch } from "react-redux";
import { setAppError } from "../../../../../../store/userSlice";

function CandidateErrorPopUp({
  showErrorPopUp,
  onToggle,
  title = "Import Aborted/Validation Error",
}) {
  const dispatch = useDispatch();

  const copyAllText = () => {
    const textToCopy = showErrorPopUp
      .map((errorMsg) => `> ${errorMsg}`)
      .join("\n");
    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        dispatch(setAppError({ msg: "Copied to Clipboard", color: "success" }));
      })
      .catch((error) => {
        // Handle any error that might occur during copying
        console.error("Unable to copy: ", error);
      });
  };
  
  return (
    <div
      className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50 justify-center items-center flex`}
    >
      <div className="w-full relative max-w-md h-auto uppercase min-h-[14rem] rounded-md bg-white/95">
        <div className="flex flex-col gap-3 px-2 py-3">
          <div className="flex justify-between items-center">
            <h2 className="block text-lg text-left font-bold text-gray-700">
              {title}
            </h2>
            <AiFillCloseCircle
              className="cursor-pointer"
              size={"1.4rem"}
              onClick={onToggle}
            />
          </div>
          <div className="px-4 text-left h-72  overflow-y-scroll">
            {showErrorPopUp.map((errorMsg, index) => {
              return (
                <h5 className="text-sm my-3" key={index}>
                  <span className="font-bold text-lg">{`>`}</span>
                  {` ${errorMsg}`}
                </h5>
              );
            })}
          </div>
          <div className="text-center mt-2">
            <button
              className="px-1 py-2 w-full max-w-xs-ultra uppercase rounded-md ring-1 ring-red disabled:bg-rose-400 text-white bg-red"
              onClick={copyAllText}
            >
              Copy
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CandidateErrorPopUp;
